var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('product',{attrs:{"categoryList":this.categoryList}}),_c('div',{staticStyle:{"background-color":"#f5f5f5","height":"1rem","margin-top":"9.375rem"}}),_c('news',{attrs:{"NewsList":this.NewsList,"IndList":this.IndList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }